import React from 'react';
import WorkspaceBreadcrumb from '../../../components/workspaces/WorkspaceBreadcrumb';

export type SegmentCrumb = { label: string; onClick?: () => void };

// The breadcrumb bar every redesigned segment screen sits under (Paper 01–04,
// "Breadcrumb"): crumbs on the left, the screen's actions on the right. Actions
// are the canonical `Button` (`@/components/ui/button`, size "workspace").
export function SegmentPageBar({ crumbs, children }: { crumbs: SegmentCrumb[]; children?: React.ReactNode }) {
  return (
    <div className="flex shrink-0 flex-wrap items-center justify-between gap-[var(--cs-segment-action-gap)] border-b border-edge bg-white px-4 py-[var(--cs-dashboard-workspace-bar-padding)] text-lg">
      <WorkspaceBreadcrumb items={crumbs} compactTitle={undefined} />
      {children && <div className="flex shrink-0 flex-wrap items-center gap-[var(--cs-segment-action-gap)]">{children}</div>}
    </div>
  );
}
